const Index = ({ children, show, isCenter }) => {
  if (show)
    return (
      <section
        className={`fixed left-0 top-0 z-[999] h-screen w-screen bg-black bg-opacity-60 ${isCenter && 'flex items-center justify-center'
          }`}
      >
        <div className="z-[501] w-11/12 md:max-w-4xl">{children}</div>
      </section>
    );
  else return null;
};

export default Index;
